import { render, staticRenderFns } from "./income-history-summary.vue?vue&type=template&id=2074af34&scoped=true"
import script from "./income-history-summary.vue?vue&type=script&lang=ts"
export * from "./income-history-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2074af34",
  null
  
)

export default component.exports